
































import { Component, Prop, Vue } from "vue-property-decorator";
// import PatternCell from './patternCell/patternCell.vue';

import * as def from "@/definitions";

// 図形
import Rectangle from "../resources/rectangle.vue";
import CircleImage from "../resources/circle.vue";
import Triangle from "../resources/triangle.vue";
import Star from "../resources/star.vue";
import Arrow from "../resources/arrow.vue";
import Polygon5 from "../resources/polygon5.vue";
import Polygon6 from "../resources/polygon6.vue";
import Polygon7 from "../resources/polygon7.vue";
import Polygon8 from "../resources/polygon8.vue";
import UTurn from "../resources/uTurn.vue";
import Cross from "../resources/cross.vue";
import Heart from "../resources/heart.vue";
import CloudPattern from "../resources/cloudPattern.vue";
import Explosion from "../resources/explosion.vue";
import RectangleBalloon from "../resources/rectangleBalloon.vue";
import RoundedRectangleBalloon from "../resources/roundedRectangleBalloon.vue";
import CircleBalloon from "../resources/circleBalloon.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    //   PatternCell
    Rectangle,
    CircleImage,
    Triangle,
    Star,
    Arrow,
    Polygon5,
    Polygon6,
    Polygon7,
    Polygon8,
    UTurn,
    Cross,
    Heart,
    CloudPattern,
    Explosion,
    RectangleBalloon,
    RoundedRectangleBalloon,
    CircleBalloon
  }
})
export default class SelectPatternBalloon extends Vue {

    select(pattern: number, cornerNumber: number, specialPatternType : string = "") {
        this.$emit("select", pattern, cornerNumber, specialPatternType);
        this.$emit("close");
    }

    close() {
        this.$emit("close");
    }
  
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
